"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hoursArrayString = exports.SCROLLBAR_WIDTH = exports.MONTH_EVENT_HEIGHT = exports.MONTH_DAY_HEADER_HEIGHT = exports.SHOW_TIME_THRESHOLD = exports.DEFAULT_HOUR_HEIGHT = exports.CALENDAR_OFFSET_LEFT = exports.HOUR_COL_HEIGHT = exports.EVENT_TABLE_DELIMITER_SPACE = exports.TABLE_COL_SPACE = exports.EVENT_TABLE_DELIMITER = exports.EVENT_MIN_HEIGHT = void 0;
exports.EVENT_MIN_HEIGHT = 25;
exports.EVENT_TABLE_DELIMITER = 1;
exports.TABLE_COL_SPACE = 5;
exports.EVENT_TABLE_DELIMITER_SPACE = 8;
exports.HOUR_COL_HEIGHT = 40;
exports.CALENDAR_OFFSET_LEFT = 40;
exports.DEFAULT_HOUR_HEIGHT = 40;
exports.SHOW_TIME_THRESHOLD = 60;
exports.MONTH_DAY_HEADER_HEIGHT = 25;
exports.MONTH_EVENT_HEIGHT = 14;
exports.SCROLLBAR_WIDTH = 15;
exports.hoursArrayString = [
    '00',
    '01',
    '02',
    '03',
    '04',
    '05',
    '06',
    '07',
    '08',
    '09',
    '10',
    '11',
    '12',
    '13',
    '14',
    '15',
    '16',
    '17',
    '18',
    '19',
    '20',
    '21',
    '22',
    '23',
];
